export default __webpack_public_path__ + "static/media/mobile_reward1_detail_6.4f7a28c9.png";